import React from 'react';
import type {CampaignProps} from '@/types/campaign';
import {computeSectionsToHide} from '../utils/briefItemFilters';
import styles from './AiBriefViewer.module.scss';
import AdditionalInformation from './sections/AdditionalInformation';
import ContentAgreement from './sections/ContentAgreement';
import CreatorDetails from './sections/CreatorDetails';
import CreatorPayments from './sections/CreatorPayments';
import Deliverables from './sections/Deliverables';
import GeneralDetails from './sections/GeneralDetails';
import TermsAndConditions from './sections/TermsAndConditions';
import TimelineOverview from './sections/TimelineOverview';

interface AiBriefViewerProps {
  campaign: CampaignProps;
}

function AiBriefViewer({campaign}: AiBriefViewerProps) {
  const sectionsToHide = computeSectionsToHide(campaign);
  const briefItems = campaign.campaignPaidGigBriefItems ?? [];

  return (
    <div className={styles.container}>
      <GeneralDetails campaign={campaign} />
      <CreatorPayments campaign={campaign} />
      <CreatorDetails
        campaign={campaign}
        briefItems={briefItems}
        sectionsToHide={sectionsToHide}
      />
      <Deliverables
        campaign={campaign}
        briefItems={briefItems}
        sectionsToHide={sectionsToHide}
      />
      <TimelineOverview campaign={campaign} />
      <AdditionalInformation
        campaign={campaign}
        briefItems={briefItems}
        sectionsToHide={sectionsToHide}
      />
      <ContentAgreement briefItems={briefItems} />
      <TermsAndConditions briefItems={briefItems} />
    </div>
  );
}

export default AiBriefViewer;
